import React from 'react';
import { autobind } from 'core-decorators';
import LucideIcon from '../componentes/lucide-icon';
import Avatar from '../componentes/avatar';
import Tooltip from '../componentes/tooltip';
import Popover from 'src/componentes/popover';
import css from '../utils/css';
import ContentManager from '../componentes/content-manager';
import Mensagem from '../paginas/mensagem/modal';
import ResponsavelLookup from '../lookups/colaborador';

const classes = css`
  .removeHover {
    transition: all ease-in-out 0.1s;
    &:hover {
      cursor: pointer;
      color: #f05050 !important;
    }
  }
  .plusButton {
    transition: all ease-in-out 0.3s;
    margin-top: 3px;
    display: flex;
    justify-content: center;
    align-items: center;
    min-width: 30px;
    max-width: 30px;
    height: 30px;
    border-radius: 30px;
    border: 1px solid #dde6e9;
    cursor: pointer;
    &:hover {
      background: rgb(221, 230, 233, 0.4);
    }
  }
`;

@autobind
class ColaboradorButtonLookup extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      responsavelLookup: false,
      colaboradorId: null,
    };
  }

  UNSAFE_componentWillReceiveProps(newprops) {
    let valueAntigo = this.props.model && this.props.model.value;
    let valueNovo = newprops.model && newprops.model.value;

    if (valueAntigo != valueNovo && !newprops.multi) {
      this.toggleLookup(false);
    }
  }

  handleChangeValue(valor) {
    this.setState({ valor: valor });
  }

  renderCartao(colaborador, onRemove) {
    return (
      <>
        <span className="tw:text-sm">
          <strong>{colaborador.nome}</strong>
        </span>
        <br></br>
        <span className="tw:text-sm">{colaborador.unidadeArea}</span>
        <div className="tw:flex tw:justify-end">
          {this.props.acaoId > 0 && (
            <LucideIcon style={{ cursor: 'pointer' }} onClick={() => this.handleMensagemClick(colaborador)} icon="comment-text-outline" />
          )}
          {onRemove && <LucideIcon onClick={onRemove} className={classes.removeHover} style={{ marginLeft: 5 }} icon="delete-outline" />}
        </div>
      </>
    );
  }

  handleMensagemClick(colaborador) {
    let { tipoLookup, acaoId } = this.props;

    this.setState({ colaboradorId: null });

    ContentManager.addContent(
      <Mensagem colaborador={colaborador} tipoLookup={tipoLookup} fromAcao={this.props.fromAcao} fromItem={this.props.fromItem} acaoId={acaoId} />
    );
  }

  toggleLookup(param) {
    this.setState({ responsavelLookup: param ? param : !this.state.responsavelLookup, colaboradorId: null }, () => {
      this.props.callbackLookup && this.props.callbackLookup(this.state.responsavelLookup);
    });
  }

  renderLabel() {
    return (
      this.props.showLabel == true && (
        <div style={{ width: '100%' }}>
          <label>
            {this.props.model && this.props.model.label} {this.props.required ? '*' : ''}
          </label>
        </div>
      )
    );
  }

  renderPlusButton(model, multi = false) {
    let error = this.getError(model);

    return (
      <div className={classes.plusButton} style={{ border: error && '1px solid rgb(240, 80, 80)', marginTop: multi && -2 }} onClick={() => this.toggleLookup()}>
        <LucideIcon style={{ color: error && 'rgb(240, 80, 80)' }} icon="plus" />
      </div>
    );
  }

  getError(model) {
    if (model && model.errors && model.errors != '') return true;

    return false;
  }

  renderSingle(model) {
    let valor = model && model.value;
    let { colaboradorId } = this.state;
    let { disabled } = this.props;

    const containerStyle = this.props.compact
      ? { display: 'flex', flexDirection: 'column', marginBottom: 0 }
      : {
          width: '100%',
          display: 'flex',
          flexDirection: 'column',
          alignItems: this.props.center == true && 'center',
        };

    return (
      <div className="form-group" style={{ ...containerStyle, ...this.props.formGroupStyle }}>
        {this.renderLabel()}
        {valor == null ? (
          this.props.exibirInputDireto || this.state.responsavelLookup ? (
            <div style={{ width: '100%' }}>
              <ResponsavelLookup {...this.props} formGroupStyle={{ marginBottom: 0 }} className="popupOpen" showLabel={false} autofocus size={30} onlyAvatar={true} clearable={false} />
            </div>
          ) : (
            <div style={{ display: 'flex' }}>
              {!disabled && this.renderPlusButton(model, false)}
            </div>
          )
        ) : (
          <Popover
            placement="right"
            className="popupOpen tw:min-w-50"
            open={colaboradorId == valor.id}
            onOpenChange={(open) => this.setState({ colaboradorId: open ? valor.id : null })}
            content={this.renderCartao(valor, () => (this.props.remove ? this.props.remove() : this.remove()))}
          >
            <div style={{ cursor: 'pointer', width: 30, display: 'flex', alignItems: 'center', marginTop: this.props.showLabel == true && 3 }}>
              <Tooltip text={valor && valor.nome} maxWidth="none">
                <Avatar foto={valor && valor.fotoArquivo} showLabel={false} border={1} size={30} label={valor && valor.nome} />
              </Tooltip>
            </div>
          </Popover>
        )}
      </div>
    );
  }

  removeMulti(index) {
    let valores = this.props.model.value;
    let valoresCopia = Object.assign([], valores);

    if (valoresCopia) {
      valoresCopia.splice(index, 1);
      this.props.model.requestChange && this.props.model.requestChange(valoresCopia);
    }
  }

  remove() {
    this.props.model.requestChange && this.props.model.requestChange(null);
  }

  renderMulti(model) {
    let values = model && model.value;
    let { colaboradorId } = this.state;
    let { disabled } = this.props;

    return (
      <div className="form-group">
        {this.renderLabel()}
        <div style={{ display: 'flex' }}>
          {!this.state.responsavelLookup ? (
            <div style={{ cursor: 'pointer', display: 'flex', alignItems: 'center', flexFlow: 'wrap', marginTop: this.props.showLabel == true && 3 }}>
              {values &&
                values.map((colaborador, index) => (
                  <Popover
                    key={index}
                    placement="right"
                    className="popupOpen tw:min-w-50"
                    open={colaboradorId == colaborador.id}
                    onOpenChange={(open) => this.setState({ colaboradorId: open ? colaborador.id : null })}
                    content={this.renderCartao(colaborador, !disabled && (() => (this.props.remove ? this.props.remove() : this.removeMulti(index))))}
                  >
                    <div style={{ marginRight: 5, marginBottom: 5 }}>
                      <Tooltip text={colaborador && colaborador.nome} maxWidth="none">
                        <Avatar foto={colaborador && colaborador.fotoArquivo} showLabel={false} border={1} size={30} label={colaborador && colaborador.nome} />
                      </Tooltip>
                    </div>
                  </Popover>
                ))}
              {!disabled && this.renderPlusButton(model, true)}
            </div>
          ) : (
            <div style={{ marginRight: 10 }}>
              <ResponsavelLookup
                {...this.props}
                formGroupStyle={{ marginBottom: 0 }}
                className="popupOpen"
                showLabel={false}
                autofocus
                size={28}
                onlyAvatar={true}
                onBlur={() => this.toggleLookup(false)}
                clearable={false}
              />
            </div>
          )}
        </div>
      </div>
    );
  }

  render() {
    return this.props.multi ? this.renderMulti(this.props.model && this.props.model) : this.renderSingle(this.props.model && this.props.model);
  }
}

export default ColaboradorButtonLookup;
